export default "__VITE_ASSET__4o89$MC4__"